<div class="upsell-steps">
  <div class="upsell-steps__container mx-auto w-full">
    <div row class="flex flex-col desktop:flex-row">
      <div *ngFor="let step of steps; index as i;trackBy: trackByFn"
          class="upsell-steps__item w-full flex items-center justify-center uppercase text-sm desktop:text-base p-2.5"
          [ngClass]="{'active' : step.active }">
          <svg class="w-4 h-4 pb-px" *ngIf="step.showCheck" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
             <polygon points="78.5,216.75 170.67,308.93 433.51,46.09 512,124.58 249.16,387.42 170.67,465.91 92.17,387.42 0,295.25 "/>
          </svg>
          <b class="mx-2">{{ stepLabel }} {{ i + 1 }}</b> {{ step.label }}
      </div>
    </div>
  </div>